const messages = {
  en: {
    address: {
      label: 'Address',
      arrayTitle: 'Adresses',
      noData: 'No address',
      placeholder: '3 road Voltaire',
    },
    city: {
      label: 'City',
      placeholder: '',
    },
    email: {
      label: 'Email',
      arrayTitle: 'Emails',
      noData: 'No emails',
      placeholder: 'JohnSmith@gmail.com',
    },
    fName: {
      label: 'First name',
      placeholder: '',
    },
    genAlpha1: {
      label: 'Gen Alpha 1',
      placeholder: '',
    },
    idBu: {
      label: 'Customer Id',
      placeholder: '12345678',
    },
    identContSourc: {
      label: 'Ident Cont Sourc',
      arrayTitle: 'Ident Cont Sourc',
      noData: 'No ident cont sourc',
      placeholder: '',
    },
    lName: {
      label: 'Last name',
      placeholder: '',
    },
    phoneNumber: {
      label: 'Phone number',
      arrayTitle: 'Number',
      arrayColumn: 'Number',
      noData: 'No phone numbers',
      placeholder: '012345678910',
    },
    plateNumber: {
      label: 'Plate number',
      placeholder: 'AA999AA',
    },
    vin: {
      label: 'Vin',
      placeholder: '',
    },
    zipCode: {
      label: 'Zip Code',
      placeholder: '75000',
    },
    close: 'X',
    menu: 'Menu',
    amount: 'Amount',
    bills: 'Bills',
    brand: 'Brand',
    cars: 'Cars',
    filters: 'Filters',
    id: 'Id',
    idLengthError: 'The Id length must be >= 5 and =< 15',
    idOnlyDigitsError: 'The Id must only contains digits',
    filterAlreadyAddedError: 'This filter is already added',
    userAlreadyAuthorized: 'This user is already authorized !',
    emailErrorMessage: 'Invalid email format',
    phoneErrorOnlyDigitsMessage: 'Only digits and spaces are accepted',
    model: 'Model',
    results: 'Results',
    type: 'Type',
    dateSale: 'Date sale',
    canalSale: 'Canal sale',
    productLabel: 'Product label',
    firstPurchaseDate: 'First purchase',
    lastPurchaseDate: 'Last purchase',
    noDataFound: 'No data found',
    googleConnect: 'Log in',
    submit: 'Submit',
    submitTooltip: {
      adress: 'If you use an adress filter, please also put either a zip_code or a city (or both)',
      atLeastOneFilter: 'You must have at least one filter',
      notConnected: 'You must be connected to make a request',
    },
    disconnect: 'Disconnect',
    resetFilters: 'Reset filters',
    unautorizedUser: 'Connection failure, email not allowed.',
    timeoutMessage: 'Connection timeout. Please log in again.',
    noResultsFound: 'No results found !',
    maxCustomerWarning: 'Only the 100 first occurencies are displayed.',
    noCars: 'No cars',
    noBills: 'No bills',
    noUserDetails: 'No user details',
    noCampaignHistory: 'No campaign history',
    customerDetails: 'Details',
    cd_sourc: 'Cd_sourc',
    optinMail: 'Optin mail',
    optinPhone: 'Optin phone',
    optinSms: 'Optin sms',
    optinPrint: 'Optin print',
    addedUser: 'Successfully added \'{user}\' !',
    deleteUser: 'Successfully deleted :', // A list of deleted users is displayed after this message
    errorOnAddUser: 'Sorry, an error occured while adding the user \'{user}\'',
    errorOnDeleteUser: 'Sorry, an error occured while deleting the user(s)',
    userIsAdmin: 'Forbidden, you can not delete ADMIN users !',
    cdShop: 'Cd shop',
    numDocSourc: 'Num Doc Sourc',
    rowNumber: 'Position',
    quantity: 'Quantity',
    users: 'Users',
    searchUserPlaceholder: 'Search user',
    deleteUserButton: 'Delete checked',
    userRole: 'Role',
    carId: 'Vehicle Id',
    billId: 'Bill Id',
    customerCars: 'Customer cars',
    nonRefCars: 'Non referenced cars',
    cdProduct: 'Code Product',
    deliveryLabel: 'Name',
    tSevent: 'Send date',
    folderLabel: 'Campaign group',
    campaignHistory: 'History Campaign',
    customerDetailSrcUpdate: 'Source update',
    customerDetaildtUpdate: 'Date update',
    errorLoadingAuthorizedUsers: 'Sorry, an error occured while retrieving authorized users',
    deleteUsersConfirmationMessage: 'Are you sure you want to delete the following(s) user(s) ?',
  },
  de: {
    city: {
      label: 'ORT',
      placeholder: 'Musterstadt',
    },
    fName: {
      label: 'VORNAME',
      placeholder: 'Erika',
    },
    lName: {
      label: 'NACHNAME',
      placeholder: 'Mustermann',
    },
    genAlpha1: {
      label: 'KONTONUMMER',
      placeholder: '12345678',
    },
    idBu: {
      label: 'KUNDENNUMMER_MOBIDATA',
      placeholder: '12345678',
    },
    identContSourc: {
      label: 'KUNDENNUMMER',
      arrayTitle: 'ALLE KUNDENNNUMMERN',
      noData: 'KEINE KUNDENNUMMERN AUS QUELLSYSTEM',
      placeholder: '111222333',
    },
    address: {
      label: 'STRASSE HAUSNUMMER',
      arrayTitle: 'ALLE ADRESSEN',
      noData: 'KEINE ADRESSEN ZU DIESEM KUNDEN',
      placeholder: 'Musterstraße 12',
    },
    zipCode: {
      label: 'PLZ',
      placeholder: '12345',
    },
    email: {
      label: 'EMAIL',
      arrayTitle: 'ALLE EMAIL ADRESSEN',
      noData: 'KEINE EMAIL ADRESSEN ZU DIESEM KUNDEN',
      placeholder: 'erika@mustermann.de',
    },
    phoneNumber: {
      label: 'TELEFON',
      arrayTitle: 'ALLE TELEFONNUMMERN',
      arrayColumn: 'TELEFONNUMMER',
      noData: 'KEINE TELEFONNUMMERN ZU DIESEM KUNDEN',
      placeholder: '012345678910',
    },
    plateNumber: {
      label: 'KENNZEICHEN',
      placeholder: 'MUEM123',
    },
    vin: {
      label: 'FIN',
      placeholder: 'WVWZZZ1JZ3W386752',
    },
    close: 'X',
    menu: 'SUCHABFRAGE',
    amount: 'UMSATZ',
    bills: 'TRANSAKTIONEN',
    brand: 'MARKE',
    cars: 'ALLE KFZ',
    filters: 'FILTER',
    id: 'AUFTRAGSNUMMER',
    idLengthError: 'DIE FELDLÄNGE IST >= 5 UND =< 15',
    idOnlyDigitsError: 'DIE ID ENTHÄLT NUR NUMERISCHE WERTE',
    filterAlreadyAddedError: 'FILTER BEREITS VORHANDEN',
    emailErrorMessage: 'FORMAT NICHT KORREKT',
    phoneErrorOnlyDigitsMessage: 'DAS FELD ENTHÄLT NUR NUMERISCHE WERTE UND LEERZEICHEN',
    model: 'MODELL',
    results: 'ERGEBNISSE',
    type: 'TYP',
    dateSale: 'DATUM',
    canalSale: 'KANAL',
    productLabel: 'ARTIKELBESCHREIBUNG',
    firstPurchaseDate: 'ERSTKAUF',
    lastPurchaseDate: 'LETZTKAUF',
    noDataFound: 'KEINE ERGEBNISSE GEFUNDEN',
    googleConnect: 'LOGIN',
    submit: 'SUCHE',
    submitTooltip: {
      adress: 'BEI DER ADRESSSUCHE BITTE MINDESTENS DIE PLZ ODER ORT (ODER BEIDES) BEFÜLLEN',
      atLeastOneFilter: 'ES MUSS MINDESTENS EIN FILTER GESETZT SEIN',
      notConnected: 'UM DIE SUCHE ZU STARTEN BITTE EINLOGGEN',
    },
    disconnect: 'LOGOUT',
    resetFilters: 'FILTER ZURÜCKSETZEN',
    unautorizedUser: 'VERBINDUNG FEHLGESCHLAGEN, EMAIL NICHT ERLAUBT.',
    timeoutMessage: 'VERBINDUNG ABGEBROCHEN. BITTE LOGGEN SIE SICH NEU EIN.',
    noResultsFound: 'KEINE ERGEBNISSE GEFUNDEN!',
    maxCustomerWarning: 'NUR DIE ERSTEN 100 DATENSÄTZE WERDEN ANGEZEIGT.',
    noCars: 'KEINE KFZ GEFUNDEN',
    noBills: 'KEINE TRANSAKTIONEN GEFUNDEN',
    noUserDetails: 'KEINEN KUNDENDATEN GEFUNDEN',
    noCampaignHistory: 'KEINE KAMPAGNENHISTORIE ZU DIESEM KUNDEN',
    customerDetails: 'KUNDENDATEN',
    cd_sourc: 'DATENQUELLE',
    optinMail: 'DNE MAIL',
    optinPhone: 'DNE TELEFON',
    optinSms: 'DNE SMS ',
    optinPrint: 'DNE PRINT',
    addedUser: 'NUTZER \'{user}\' ERFOLGREICH HINZUGEFÜGT!',
    deleteUser: 'NUTZER ERFOLGREICH GELÖSCHT:', // A list of deleted users is displayed after this message
    errorOnAddUser: 'TUT MIR LEID, ES IST EIN FEHLER AUFGETRETEN BEI DER EINGABE VON NUTZER \'{user}\'',
    errorOnDeleteUser: 'TUT MIR LEID, ES IST EIN FEHLER AUFGETRETEN BEIM LÖSCHEN VON/DER NUTZER',
    userIsAdmin: 'ZUGRIFF VERWEIGERT!',
    cdShop: 'FILIALNUMMER',
    numDocSourc: 'AUFTRAGSNUMMER_QUELLSYSTEM',
    rowNumber: 'POSITION',
    quantity: 'MENGE',
    users: 'NUTZER',
    searchUserPlaceholder: 'SUCHE NUTZER',
    deleteUserButton: 'NUTZER ENTFERNEN',
    userRole: 'PROFIL',
    carId: 'KFZ_ID_MOBIDATA',
    billId: 'AUFTRAGSNUMMER_MOBIDATA',
    customerCars: 'ALLE KFZ DES KUNDEN',
    nonRefCars: 'NICHT ZUGEORDNETE KFZ',
    cdProduct: 'ARTIKELNUMMER',
    deliveryLabel: 'NAME',
    tSevent: 'VERSANDDATUM',
    folderLabel: 'KAMPAGNENGRUPPE',
    campaignHistory: 'CRM KAMPAGNEN KONTAKTHISTORIE KUNDE',
    customerDetailSrcUpdate: 'QUELLE UPDATE',
    customerDetaildtUpdate: 'DATUM UPDATE',
    errorLoadingAuthorizedUsers: 'FEHLER BEIM LADEN DER AUTHORISIERTEN NUTZER',
    deleteUsersConfirmationMessage: 'MÖCHTEN SIE FOLGENDE/N NUTZER LÖSCHEN?',
  }
}

// Used to force the browser language during local cypress tests.
// Else, it takes the local language but we must force it to be english (en).
var forcedLanguage = require('./../config/dev.env.js').BROWSER_LANGUAGE

var browserLanguage = navigator.language || navigator.userLanguage
if (forcedLanguage) {
  forcedLanguage = forcedLanguage.replace(/\"/g, "")
  browserLanguage = forcedLanguage
}
if (browserLanguage.substring(0,2) == "de") {
  browserLanguage = "de"
}

module.exports = {
  messages: messages,
  browserLanguage: browserLanguage,
}



// WEBPACK FOOTER //
// ./src/translations.js